/**
 * TanStack Query hooks for `custom-payout-rules-per-influencer-tier`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customPayoutRulesPerInfluencerTierQueryKeys,
	type CreateCustomPayoutRulesPerInfluencerTierBody,
	type ListCustomPayoutRulesPerInfluencerTierResponse,
	type CustomPayoutRulesPerInfluencerTierRow,
} from "./api";

export function useCustomPayoutRulesPerInfluencerTierList(): UseQueryResult<ListCustomPayoutRulesPerInfluencerTierResponse, Error> {
	return useQuery({
		queryKey: customPayoutRulesPerInfluencerTierQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomPayoutRulesPerInfluencerTierCreate(): UseMutationResult<CustomPayoutRulesPerInfluencerTierRow, Error, CreateCustomPayoutRulesPerInfluencerTierBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPayoutRulesPerInfluencerTierQueryKeys.all });
		},
	});
}

export function useCustomPayoutRulesPerInfluencerTierDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPayoutRulesPerInfluencerTierQueryKeys.all });
		},
	});
}
